import type { ApiError } from '../../api/client';
export interface RewardIntent {
  owner: number;
  key: string;
  kind: 'streak' | 'task' | 'story';
  taskId?: string;
  period?: string;
  templateId?: string;
  shareProof?: string;
  unknown?: boolean;
}
const storageKey = (owner: number) => `steos:rewards:pending:${owner}`;
export function readRewardIntent(owner: number): RewardIntent | null {
  const raw = sessionStorage.getItem(storageKey(owner));
  if (!raw) return null;
  const value = JSON.parse(raw) as RewardIntent;
  if (
    value.owner !== owner ||
    !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.key) ||
    !['streak', 'task', 'story'].includes(value.kind)
  )
    throw new Error('reward_intent_invalid');
  if (value.kind !== 'streak' && (typeof value.taskId !== 'string' || !value.taskId || value.taskId.length > 128))
    throw new Error('reward_intent_invalid');
  if (
    value.kind === 'story' &&
    (typeof value.templateId !== 'string' ||
      !value.templateId ||
      value.templateId.length > 64 ||
      typeof value.shareProof !== 'string' ||
      !value.shareProof ||
      value.shareProof.length > 4096)
  )
    throw new Error('reward_intent_invalid');
  return value;
}
export const saveRewardIntent = (intent: RewardIntent) => sessionStorage.setItem(storageKey(intent.owner), JSON.stringify(intent));
export const clearRewardIntent = (owner: number) => sessionStorage.removeItem(storageKey(owner));
export const definitiveRewardError = (error: ApiError) =>
  [400, 403, 404, 409, 422, 428].includes(error.status) &&
  [
    'reward_claimed',
    'reward_not_ready',
    'reward_task_invalid',
    'reward_expiry_policy_missing',
    'product_not_found',
    'product_unavailable',
    'story_material_expired',
  ].includes(error.code);
